import { AfterViewChecked, Component, OnInit } from '@angular/core';
// tslint:disable-next-line: max-line-length
import {
  AddressService,
  CoreService,
  CardSetTransformationService,
  CardSetHeaderConfiguration,
  CardSetFooterConfiguration,
  CardSetMenuConfiguration,
  DialogService,
  FormConfigurationService,
  FileService,
  FooterConfiguration,
  FooterLinkColumnConfiguration,
  HeaderService,
  HeaderConfiguration,
  MenuConfigService,
  MenuService,
  UserService,
  FormConfigurationRequest
} from 'dspx-core';
import { take } from 'rxjs/operators';
import { API_ENDPOINT_KEYS, API_ENDPOINTS } from './constants/api-endpoints.constants';
import { TEMPLATES, TEMPLATE_NAMES, VERSIONS } from './constants/templates.constants';
import { DashboardCurrentNavigation } from './interfaces/dashboard-current-navigation.interface';
import { AppDataService } from './services/app-data.service';
import { APP_DATA_KEYS, APPLICATION, POP_UP_CODES, POP_UP_TEXTS } from "./constants/app-data.constants";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(
    private appDataService: AppDataService,
    private coreService: CoreService,
    private addressService: AddressService,
    private fileService: FileService,
    private userService: UserService,
    private formConfigurationService: FormConfigurationService,
    private menuService: MenuService,
    private headerService: HeaderService,
    private cardSetTransformationService: CardSetTransformationService,
    private dialogService: DialogService,
    protected menuConfigService: MenuConfigService
  ) {
  }

  environmentBannerMessage: string;
  environmentBannerBgColor: string;
  environmentBannerColor: string;
  headerConfig: CardSetHeaderConfiguration;
  footerConfig: CardSetFooterConfiguration;
  menuConfig: CardSetMenuConfiguration;

  public headerLinks: any = {};
  public isMenuVisible: boolean = false;  //Set this to false if you have an app that starts on an unauthenticated component.
  public showLogout: boolean = false;     //Set this to false if you have an app that starts on an unauthenticated component.
  //app-data.service.ts has a function called 'getUserDetails' (that you can modify to your liking) which you can call from
  //an authenticated component to set the header config with the user details and display a menu with the logout option.

  ngOnInit() {

    this.menuService.menuLoaded$.subscribe((config) => {
      if (config) {
        this.menuConfig = config;
      }
    });

    this.headerService.headerUpdated$.subscribe((config) => {
      if (config) {
        this.headerConfig = config;
      }
    });

    this.menuConfigService.styleConfigService.layoutMode =
      'static'; /*'overlay';*/ /*'horizontal';*/ /*'slim';*/
    this.menuConfigService.styleConfigService.layoutColor = /*'dark';*/ 'light';
    this.menuConfigService.styleConfigService.darkMenu = /*true;*/ false;
    this.menuConfigService.styleConfigService.ripple = true; /*false;*/
    this.menuConfigService.styleConfigService.inputStyle = 'outlined'; /*'filled';*/

    this.menuConfigService.primengConfig.ripple =
      this.menuConfigService.styleConfigService.ripple;

    this.userService.endpoints = {
      getLoggedInUser: API_ENDPOINTS.user.getLoggedInUser,
    };

    this.formConfigurationService.endpoints = {
      getFormConfig: API_ENDPOINTS.configuration.default,
      getRuleConfigAndResponse: API_ENDPOINTS.paymentRule.getConfigAndResponse,
      getReferenceDataConfigAndResponse: API_ENDPOINTS.referenceData.getConfigAndResponse,
      getVictorianPatientTransportAssistanceSchemeReferenceDataConfigAndResponse: API_ENDPOINTS.referenceData.victorianPatientTransportAssistanceScheme.getConfigAndResponse,
      getGlStringMappingConfigAndResponse: API_ENDPOINTS.glStringMapping.getConfigAndResponse,
      getGlStringLookupMappingSetConfigAndResponse: API_ENDPOINTS.glStringLookupMappingSet.getConfigAndResponse,
      getGlStringLookupMappingConfig: API_ENDPOINTS.glStringLookupMapping.getConfig,
      getGlStringLookupMappingConfigAndResponse: API_ENDPOINTS.glStringLookupMapping.getConfigAndResponse,
      getSettingConfigAndResponse: API_ENDPOINTS.setting.getConfigAndResponse,
      getUserConfigAndResponse: API_ENDPOINTS.user.getConfigAndResponse,
      getOrganisationConfigAndResponse: API_ENDPOINTS.organisation.getConfigAndResponse,
      getApplicationDetailCreateUpdateCarerConfigAndResponse: API_ENDPOINTS.applicationDetailCreateUpdateCarer.getConfigAndResponse,
      getApplicationDetailCreateUpdatePlacementConfigAndResponse: API_ENDPOINTS.applicationDetailCreateUpdatePlacement.getConfigAndResponse,
      getCareAllowancePlacementRuleConfigAndResponse: API_ENDPOINTS.careAllowancePlacementRule.getConfigAndResponse,
      getCareAllowanceFinancialYearListConfig: API_ENDPOINTS.careAllowanceFinancialYear.getListConfig,
      getCareAllowanceCalendarYearListConfig: API_ENDPOINTS.careAllowanceCalendarYear.getListConfig,
      getCareAllowanceFinancialYearConfig: API_ENDPOINTS.careAllowanceFinancialYear.getConfig,
      getCareAllowanceCalendarYearConfig: API_ENDPOINTS.careAllowanceCalendarYear.getConfig,
      getCareAllowanceFinancialYearConfigAndResponse: API_ENDPOINTS.careAllowanceFinancialYear.getConfigAndResponse,
      getCareAllowanceCalendarYearConfigAndResponse: API_ENDPOINTS.careAllowanceCalendarYear.getConfigAndResponse,
      getCareAllowanceFinancialYearConfigAndResponseWithGeneratedInvoicePeriods: API_ENDPOINTS.careAllowanceFinancialYear.getConfigAndResponseGenerateInvoicePeriods,
      getCareAllowanceCalendarYearConfigAndResponseWithGeneratedInvoicePeriods: API_ENDPOINTS.careAllowanceCalendarYear.getConfigAndResponseGenerateInvoicePeriods,
      getCareAllowanceInvoicePeriodConfigAndResponse: API_ENDPOINTS.careAllowanceInvoicePeriod.getConfigAndResponse,
      getCareAllowanceApprovedRateListConfig: API_ENDPOINTS.careAllowanceRate.getApprovedRateListConfig,
      getCareAllowancePendingRateListConfig: API_ENDPOINTS.careAllowanceRate.getPendingRateListConfig,
      getCareAllowanceRateConfigAndResponse: API_ENDPOINTS.careAllowanceRate.getConfigAndResponse,
      getCareAllowancePlacementConfigAndResponse: API_ENDPOINTS.careAllowancePlacement.getConfigAndResponse,
      getCareAllowanceLocalAdoptionConfigAndResponse: API_ENDPOINTS.careAllowancePlacement.getLocalAdoptionConfigAndResponse,
      getNewCareAllowanceLocalAdoptionConfigAndResponse: API_ENDPOINTS.careAllowancePlacement.getNewLocalAdoptionConfigAndResponse,
      getCareAllowancePlacementAdjustmentConfig: API_ENDPOINTS.careAllowancePlacementAdjustment.getConfig,
      getCareAllowancePlacementAdjustmentConfigAndResponse: API_ENDPOINTS.careAllowancePlacementAdjustment.getConfigAndResponse,
      getCareAllowancePlacementAdjustmentConfigAndResponseWithGeneratedLines: API_ENDPOINTS.careAllowancePlacementAdjustment.getConfigAndResponseGeneratedAdjustmentLines,
      getCareAllowancePlacementBulkAdHocInvoiceQueryConfigAndResponse: API_ENDPOINTS.careAllowancePlacementBulkAdHocInvoiceQuery.getConfigAndResponse,
      getIccmsRequestProcessingScheduleConfigAndResponse: API_ENDPOINTS.iccmsRequestProcessingSchedule.getConfigAndResponse,
      getPersonConfigAndResponse: API_ENDPOINTS.person.getConfigAndResponse,
      getPersonListConfig: API_ENDPOINTS.person.getPersonListConfig,
      getPersonListConfigForCarerApplicationUpdate: API_ENDPOINTS.person.getPersonListConfigForCarerApplicationUpdate,
      getPersonListConfigForPlacementApplicationUpdate: API_ENDPOINTS.person.getPersonListConfigForPlacementApplicationUpdate,
      getPersonBankDetailResponseAndConfig: API_ENDPOINTS.person.getPersonBankDetailResponseAndConfig,
      getVendorConfigAndResponse: API_ENDPOINTS.vendor.getConfigAndResponse,
      getVmgEmailTemplateConfigAndResponse: API_ENDPOINTS.applicationDetailCreateUpdateCarer.getVmgEmailTemplateConfigAndResponse,
      getConcessionsApplicationDetailsConfigAndResponse: API_ENDPOINTS.concessionsApplicationDetails.getConfigAndResponse,
      getConcessionsApplicationNonMainsWaterConfigAndResponse: API_ENDPOINTS.concessionsApplicationNonMainsWater.getConfigAndResponse,
      getConcessionsApplicationNonMainsEnergyConfigAndResponse: API_ENDPOINTS.concessionsApplicationNonMainsEnergy.getConfigAndResponse,
      getConcessionsApplicationNonMainsLifeSupportConfigAndResponse: API_ENDPOINTS.concessionsApplicationNonMainsLifeSupport.getConfigAndResponse,
      getConcessionsApplicationNonMainsMedicalCoolingConfigAndResponse: API_ENDPOINTS.concessionsApplicationNonMainsMedicalCooling.getConfigAndResponse,
      getConcessionsApplicationEdaAndPowGoldCardMunicipalRatesConfigAndResponse: API_ENDPOINTS.concessionsApplicationEdaAndPowGoldCardMunicipalRates.getConfigAndResponse,
      getConcessionsApplicationRebateCalculationRuleListConfigConfigAndResponse: API_ENDPOINTS.concessionsApplicationRebateCalculationRule.getConfigAndResponse,
      getConcessionsApplicationApprovedRebateCalculationRuleListConfig: API_ENDPOINTS.concessionsApplicationRebateCalculationRule.getApprovedRebateCalculationRuleListConfig,
      getConcessionsApplicationPendingRebateCalculationRuleListConfig: API_ENDPOINTS.concessionsApplicationRebateCalculationRule.getPendingRebateCalculationRuleListConfig,
      getConcessionsRebateCalculationRuleConfigAndResponse: API_ENDPOINTS.concessionsApplicationRebateCalculationRule.getConfigAndResponse,
      getJobScheduleConfigAndResponse: API_ENDPOINTS.jobSchedule.getConfigAndResponse,
      getExportedInvoiceConfigAndResponse: API_ENDPOINTS.exportedInvoice.getConfigAndResponse,
      getReportListConfigAndResponse: API_ENDPOINTS.dashboard.getReportListConfigAndResponse,
      getAgencyConfig: API_ENDPOINTS.agency.getConfig,
      getAgencyConfigAndResponse: API_ENDPOINTS.agency.getConfigAndResponse,
      getConcessionsApplicationBulkUploadDetailConfigAndResponse: API_ENDPOINTS.concessionsApplicationBulkUploadDetail.getConfigAndResponse,
      getCareAllowancePersonConfigAndResponse: API_ENDPOINTS.careAllowancePerson.getConfigAndResponse,
      getVictorianPatientTransportAssistanceSchemeApprovedRebateRateListConfig: API_ENDPOINTS.victorianPatientTransportAssistanceSchemeRebateRate.getApprovedRebateRateListConfig,
      getVictorianPatientTransportAssistanceSchemePendingRebateRateListConfig: API_ENDPOINTS.victorianPatientTransportAssistanceSchemeRebateRate.getPendingRebateRateListConfig,
      getVictorianPatientTransportAssistanceSchemeRebateRateConfigAndResponse: API_ENDPOINTS.victorianPatientTransportAssistanceSchemeRebateRate.getConfigAndResponse,
      getVptasApplicationDetailsConfigAndResponse: API_ENDPOINTS.vptasApplicationDetails.getApplicationDetailsConfigAndResponse,
      getVptasApplicationConfigAndResponse: API_ENDPOINTS.victorianPatientTransportAssistanceSchemeApplication.getConfigAndResponse,
      getVptasNominatedPatientFormConfig: API_ENDPOINTS.vptasNominatedPatient.getConfigAndResponse,
      getVictorianPatientTransportAssistanceSchemeNominatedPatientDetails: API_ENDPOINTS.vptasNominatedPatient.getConfigAndResponse,
      getVictorianPatientTransportAssistanceSchemeApplication: API_ENDPOINTS.victorianPatientTransportAssistanceSchemeApplication.getConfigAndResponse,
      getVptasApprovedApplicationListConfig: API_ENDPOINTS.victorianPatientTransportAssistanceSchemeApplication.getApprovedApplicationListConfig,
      getVptasPendingApplicationListConfig: API_ENDPOINTS.victorianPatientTransportAssistanceSchemeApplication.getPendingApplicationListConfig,
      getVptasSpecialistConfig: API_ENDPOINTS.vptasSpecialist.getConfigAndResponse,
      getVptasLgaConfigAndResponse: API_ENDPOINTS.vptasLga.getConfigAndResponse,
      getVptasSpecialistProviderConfigAndResponse: API_ENDPOINTS.vptasSpecialist.getProviderConfigAndResponse,
      getVptasAdjustmentApplicationConfigAndResponse: API_ENDPOINTS.vptasAdjustmentApplication.getConfigAndResponse,
      getApplicationSubsidyConfigAndResponse: API_ENDPOINTS.vptasApplicationDetails.getApplicationSubsidyConfigAndResponse,
    }

    this.addressService.endpoints = {
      //Note: Do not change the 'addressApiSearchEndpoint' and 'addressApiLgaEndpoint' key names, these are used within dspx-core.
      addressApiSearchEndpoint: API_ENDPOINTS.address.search,
      addressApiLgaEndpoint: API_ENDPOINTS.address.lga
    }

    this.coreService.fileUploadFormIdentifiers = {};
    this.fileService.endpoints = {
      //Note: By default, we use the "Document/FlagForRemoval" endpoint as the fileRemoveEndpoint. This endpoint calls a function that marks the file
      //for deletion and allows the deletion to be deferred to an appropriate time. This is required for the scenario where a form with a file upload
      //control allows edits. If a user edits the form and clicks Remove on an uploaded file, we do not want the file to be immediately deleted
      //from the document management service as the user may not end up saving the form to commit the changes. Therefore, we need to defer the deletion
      //of the file until they save the form, hence the need to mark the file for deletion. If the file can be deleted immediately, use "Document/Remove"
      //as the fileRemoveEndpoint.
      fileUploadEndpoint: 'Document/Upload',
      fileRemoveEndpoint: 'Document/FlagForRemoval',
      fileDeleteEndpoint: 'Document/Remove',
      fileDownloadEndpoint: 'api/Document/Download'
    }

    this.coreService.applicationFunctions = {};

    this.coreService.conditionFunctions = {};

    this.coreService.pageFunctions = {};

    this.coreService.repeatingPageFunctions = {};

    this.coreService.repeatingSectionFunctions = {};

    // Configure application keys
    this.appDataService.setAppData(APP_DATA_KEYS.maxGridRowCount, this.appDataService.getValueAttributeFromHtmlElement('maxGridRowCount'));

    const getFromHtmlAndSaveToAppData = (htmlElementIdAndAppDataKey: string) =>
      this.appDataService.setAppData(
        htmlElementIdAndAppDataKey,
        this.appDataService.getValueAttributeFromHtmlElement(htmlElementIdAndAppDataKey));

    getFromHtmlAndSaveToAppData(APP_DATA_KEYS.maxBulkOperationItemCount);


    // Configure the environment banner
    const environmentName =
      this.appDataService.getValueAttributeFromHtmlElement('environmentName');
    if (environmentName) {
      this.environmentBannerMessage = `You are using the ${environmentName} environment`;
    }
    const environmentBannerBgColor =
      this.appDataService.getValueAttributeFromHtmlElement(
        'environmentBannerBgColor'
      );
    if (environmentBannerBgColor) {
      this.environmentBannerBgColor = environmentBannerBgColor;
    }
    const environmentBannerColor =
      this.appDataService.getValueAttributeFromHtmlElement(
        'environmentBannerColor'
      );
    if (environmentBannerColor) {
      this.environmentBannerColor = environmentBannerColor;
    }

    // we are using MS Identity so redirect to MicrosoftIdentity Web UI Account Controller action
    this.userService.logout = () => {
      window.open('MicrosoftIdentity/Account/SignOut', '_self');
    };

    this.headerConfig = {
      applicationTitle: {
        label: APPLICATION.title,
      },
      applicationLogo: {
        source: APPLICATION.logo,
      },
    };

    // Configure the footer
    this.footerConfig = {
      footerLinkColumnsHeadingLevel: 4,
      lightModeLogo: '/assets/images/sgv-logo-dark.png',
      darkModeLogo: '/assets/images/sgv-logo.png',
      atsiLogo: '/assets/images/logo-a-tsi-flag.svg',
      prideLogo: '/assets/images/flag-pride.svg',
      prideDeclaration:
        'The Department of Families, Fairness and Housing celebrates, values and includes people of all backgrounds, genders, sexualities, cultures, bodies and abilities.',
      atsiDeclaration:
        'The department acknowledges Aboriginal and Torres Strait Islander people as the Traditional Custodians of the land and acknowledges and pays respect to their Elders, past and present.',
      footerLinkColumns: [
        {
          heading: 'About the site',
          links: [
            {
              label: 'Accessibility',
              altText: 'Accessibility ',
              url: 'https://services.dffh.vic.gov.au/accessibility/'
            },
            {
              label: 'Copyright',
              altText: 'Copyright',
              url: 'https://services.dffh.vic.gov.au/copyright/'
            },
            {
              label: 'Disclaimer',
              altText: 'Disclaimer',
              url: 'https://services.dffh.vic.gov.au/disclaimer/'
            },
            {
              label: 'Privacy statement (DFFH)',
              altText: 'Privacy statement (DFFH)',
              url: 'https://services.dffh.vic.gov.au/privacy-statement/'
            }
          ]
        },
        {
          heading: 'Related sites',
          links: [
            {
              label: 'Department of Families, Fairness and Housing',
              altText: 'Department of Families, Fairness and Housing',
              url: 'https://www.dffh.vic.gov.au/',
            },
            {
              label: 'Concessions & Benefits',
              altText: 'Concessions & Benefits',
              url: 'https://services.dffh.vic.gov.au/concessions-and-benefits',
            },
            {
              label: 'Make a complaint',
              altText: 'Make a complaint',
              url: 'https://www.dffh.vic.gov.au/making-complaint',
            },
            {
              label: 'Leave feedback online',
              altText: 'Leave feedback online',
              url: 'https://services.dffh.vic.gov.au/website-feedback',
            }
          ]
        }
      ],
      departmentName: '',
      governmentName: '',
      showAppLogo: false,
      lightModeAppLogo: '/assets/images/OSCAR_Logo_V__RGB__Navy_Turquoise.svg',
      darkModeAppLogo: '/assets/images/OSCAR_Logo_V__RGB__Navy_Turquoise.svg',
    };

    // Get Logged In User and update header
    this.userService
      .getLoggedInUser('getLoggedInUser')
      .pipe(take(1))
      .subscribe((userProfile) => {
        this.headerConfig = {
          applicationTitle: {
            label: APPLICATION.title,
          },
          applicationLogo: {
            source: APPLICATION.logo,
          },
          loggedInUser: {
            name: userProfile.fullName,
            imageSource: '/assets/images/avatar.png',
            imageDescription: userProfile.fullName,
            menuSubItems: [
              {
                label: 'Logout',
                icon: 'pi pi-fw pi-sign-out',
                routerLink: 'logout',
              },
            ],
          },
        };
        this.headerService.onHeaderUpdated(this.headerConfig);
      });

    // Configure the menu
    const request: FormConfigurationRequest = {
      apiEndpointKey: API_ENDPOINT_KEYS.getFormConfig,
      templateId: TEMPLATES.menu,
      versionNo: VERSIONS.latest,
      entityId: null,
    };
    this.formConfigurationService
      .getFormConfigAndResponse(request)
      .pipe(take(1))
      .subscribe((data) => {
        this.menuConfig =
          this.cardSetTransformationService.extractMenuConfigFromFormConfig([
            data.configData.config,
          ]);
        this.menuService.onMenuLoad(this.menuConfig);
      });

    this.dialogService.updatePopupText(
      POP_UP_CODES.common.confirmDocumentDeletion,
      POP_UP_TEXTS.common.confirmDocumentDeletion);

  }

}
